import React from 'react';
import { Infinity as InfinityIcon, CalendarDays } from 'lucide-react';

const OPTIONS = [
  ['lifetime', 'Grant lifetime access', 'Full access every day, forever', InfinityIcon],
  ['custom', 'Customise', 'Only on the days you pick in the calendar', CalendarDays],
];

export const AccessTypePicker = ({ value, onChange, testPrefix = 'access-type' }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
    {OPTIONS.map(([key, title, desc, Icon]) => (
      <button key={key} type="button" data-testid={`${testPrefix}-${key}`} onClick={() => onChange(key)}
        className={`text-left rounded-2xl border-2 p-4 transition-colors ${value === key ? 'border-amber-500 bg-amber-100 shadow-sm' : 'border-amber-200 bg-white hover:bg-amber-50'}`}>
        <div className="flex items-center gap-2 font-bold text-amber-900"><Icon size={18} />{title}</div>
        <div className="text-sm text-slate-600 mt-1">{desc}</div>
      </button>
    ))}
  </div>
);
